import Router from 'vue-router'
import Personalize from './views/Personalize.vue'
import Accessories from './views/Accessories'
import YourBike from './views/YourBike'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  routes: [
    {
      path: '/',
      name: 'personalize',
      component: Personalize
    },
    {
      path: '/accessories',
      name: 'accessories',
      component: Accessories
    },
    {
      path: '/your-bike',
      name: 'your_bike',
      component: YourBike
    },

    {
      path: '/style_guide',
      name: 'style_guide',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "styleGuide" */ './views/StyleGuide.vue')
    },
  ]
})
